import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, DateTimeOptions } from 'luxon';

// Use luxon to manage dates
@Pipe({
  name: 'aliveDate',
  standalone: true,
})
export class AliveDatePipe implements PipeTransform {
  transform(
    value: Date | string | number,
    meetTimeFormat: number = 12, // 12 or 24 - old way to do 24 hr time and uk-style dates
    format?: string | Intl.DateTimeFormatOptions,
    timezone?: string,
  ): string | null {
    if (value == null || value === '' || value !== value) return null;
    let locale = $localize.locale ?? 'en-US';
    if (meetTimeFormat === 24 && locale === 'en-US') {
      locale = 'en-GB';
    }

    let options: DateTimeOptions = {};
    if (timezone) {
      options = { zone: timezone };
    }

    //  TODO: Add Locale support
    if (typeof format === 'string') {
      return DateTime.fromISO(value.toString(), options).setLocale(locale).toFormat(format);
    } else {
      return DateTime.fromISO(value.toString(), options).setLocale(locale).toLocaleString(format);
    }
  }
}
